import React, { useState } from "react";
import "./calculateTask3LG.less";

const phaseMap: { [key: string]: string } = {
  V: "气相",
  L: "液相",
  VL: "气液混合",
};

const temperatureUnits = ["℃", "K"];
const pressureUnits = ["Pa", "bar", "KPa", "MPa", "atm"];

interface Props {
  streams: any[];
  isHide: boolean;
}

const ResultStreamDataTable: React.FC<Props> = ({ streams, isHide }) => {
  const [tempUnit, setTempUnit] = useState<string>("℃");
  const [pressUnit, setPressUnit] = useState<string>("MPa");

  const fmt = (v: any, n = 2) =>
    v == null || isNaN(Number(v)) ? "—" : Number(v).toFixed(n);

  const getT = (s: any) => tempUnit === "℃" ? s.T_C : s.T_K;
  const getP = (s: any) => s?.[`P_${pressUnit}`];

  return (
    <div className="result-stream-data-table-container">
      {/* 单位切换 */}
      <div className="unit-selector-container">
        <div className="unit-selector">
          <span className="unit-selector-label">流股数据：</span>
          <span className="unit-selector-label">温度单位：</span>
          <div className="unit-buttons">
            {temperatureUnits.map((u) => (
              <button
                key={u}
                className={`unit-button ${tempUnit === u ? "active" : ""}`}
                onClick={() => setTempUnit(u)}
              >
                {u}
              </button>
            ))}
          </div>
        </div>
        <div className="unit-selector pressure-selector">
          <span className="unit-selector-label">压力单位：</span>
          <div className="unit-buttons">
            {pressureUnits.map((u) => (
              <button
                key={u}
                className={`unit-button ${pressUnit === u ? "active" : ""}`}
                onClick={() => setPressUnit(u)}
              >
                {u}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* 表格 */}
      <div className="table-container">
        <div className="table-scroll-wrapper">
          <table className="stream-data-table">
            <thead>
              {/* 第一层表头 */}
              <tr className="table-header">
                <th rowSpan={2}>流股</th>
                <th rowSpan={2}>相态</th>
                <th colSpan={isHide ? 1 : 2}>温度({tempUnit})</th>
                <th colSpan={isHide ? 1 : 2}>压力({pressUnit})</th> 
                <th colSpan={isHide ? 1 : 2}>摩尔流量(mol/h)</th>
                <th colSpan={isHide ? 1 : 2}>质量流量(kg/h)</th>
                <th colSpan={isHide ? 1 : 2}>气化率</th>
                <th colSpan={isHide ? 1 : 2}>焓(J/mol)</th>
              </tr>
              {/* 第二层表头 */}
              {isHide ? null : (<>
              <tr className="table-header">
                <th>设计值</th><th>计算值</th>
                <th>设计值</th><th>计算值</th>
                <th>设计值</th><th>计算值</th>
                <th>设计值</th><th>计算值</th>
                <th>设计值</th><th>计算值</th>
                <th>设计值</th><th>计算值</th>
              </tr>
              </>)}
              
            </thead>
            <tbody>
              {streams.length > 0 ? (
                streams.map((s, i) => {
                  const d = s.design ?? {};
                  return (
                    <tr key={i} className="table-row">
                      {(isHide ? <>
                      <td>{s.name}</td>
                      <td>{phaseMap[s.phase] ?? s.phase ?? "—"}</td>
                      <td>{fmt(getT(s))}</td>
                      <td>{fmt(getP(s), 4)}</td>
                      <td>{fmt(s.f_mol_per_h)}</td>
                      <td>{fmt(s.f_kg_per_h)}</td>
                      <td>{fmt(s.vf, 4)}</td>
                      <td>{fmt(s.H)}</td>
                      </> : (
                        <>
                        <td>{s.name}</td>
                        <td>{phaseMap[s.phase] ?? s.phase ?? "—"}</td>
                      <td>{fmt(getT(d))}</td>
                      <td>{fmt(getT(s))}</td>
                      <td>{fmt(getP(d), 4)}</td>
                      <td>{fmt(getP(s), 4)}</td>
                      <td>{fmt(d.f_mol_per_h)}</td>
                      <td>{fmt(s.f_mol_per_h)}</td>
                      <td>{fmt(d.f_kg_per_h)}</td>
                      <td>{fmt(s.f_kg_per_h)}</td>
                      <td>{fmt(d.vf, 4)}</td>
                      <td>{fmt(s.vf, 4)}</td>
                      <td>{fmt(d.H)}</td>
                      <td>{fmt(s.H)}</td>
                        </>
                      ))}
                      
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={14} className="empty-cell">请选择流股</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ResultStreamDataTable;